export interface LifeCycleAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/discovery-lab/life-cycle-pond';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): LifeCycleAsset => ({ key, path: `${ROOT}/${path}`, width, height, alpha, required: true });

export const LIFE_CYCLE_ASSETS = {
  dormant: image('life-cycle-dormant', 'backgrounds/life-cycle-pond-dormant.png', 1280, 720, false),
  restored: image('life-cycle-restored', 'backgrounds/life-cycle-pond-restored.png', 1280, 720, false),
  card: image('life-cycle-card', 'interactives/life-cycle-card.png', 640, 480, true),
} as const;

export const LIFE_CYCLE_ASSET_LIST = Object.values(LIFE_CYCLE_ASSETS);
// Browser/PWA runtime QA is required before opening this route to players.
export const LIFE_CYCLE_PRODUCTION_READY = true;

export function preloadLifeCycleAssets(scene: Phaser.Scene): void {
  LIFE_CYCLE_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingLifeCycleAssets(
  textures: Phaser.Textures.TextureManager,
): LifeCycleAsset[] {
  return LIFE_CYCLE_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterLifeCyclePond(textures: Phaser.Textures.TextureManager): boolean {
  return LIFE_CYCLE_PRODUCTION_READY && getMissingLifeCycleAssets(textures).length === 0;
}
